var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"getAuthCode-btn",class:_vm.canClick ? '' : 'disabled',on:{"click":function($event){return _vm.sendVerifyCode(_vm.phone)}}},[_vm._v(" "+_vm._s(_vm.buttonTxt)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }